import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { getRelationkeyLabel } from 'Services/WeaverUtils';
import withFilterData from './withFilterData';
import { setRelationFilters, updateRelationFilter, updateRelationFilters } from 'Actions/graphFilter';
import { store } from '~/Store';
import { RELATION } from 'Types';
import { DisabledRelations } from 'Model';
import FilterHeader from './FilterHeader';
import FilterBody from './FilterBody';
import GraphFilterItem from './GraphFilterItem';
import tabStyles from './tabStyles';

const getRelations = ({ edges, selectedItems }) =>
  _.reduce(edges, (acc, relation) => {
    const { id, key } = relation;
    if (!key) return acc;
    acc[key] = {
      key,
      enabled: selectedItems.find((item) => item.key === key) ? selectedItems.find((item) => item.key === key).enabled : true,
      label: getRelationkeyLabel(key, id)
    };
    return acc;
  }, {});

const relationFilterSelector = createSelector(
  (state) => state.graphFilter.relationFilters,
  _.values
);

const GraphFilterRelations = ({ items }) => {
  const dispatch = useDispatch();
  const relationFilters = useSelector(relationFilterSelector);

  const [filterValue, setFilterValue] = useState("");
  const [configNode, setConfigNode] = useState(undefined);

  useEffect(() => {
    const sorted = _.sortBy(items, [(item) => item.label.toLowerCase()])
    dispatch(setRelationFilters(_.keyBy(sorted, 'key')));
    (async () => {
      setConfigNode(await DisabledRelations.load());
    })();
  }, [items]);

  const CellRenderItem = ({ item, ...props }) => {
    const { explore: { disabledRelations } } = store.getState();
    const enableByDefault = !disabledRelations.includes(item.key);
    const itemProps = {
      itemType: RELATION,
      enabled: item.enabled,
      value: item.key,
      label: item.label,
      enableByDefault,
      ...props
    };

    return <GraphFilterItem {...itemProps} />;
  };

  return (
    <div style={tabStyles}>
      <FilterHeader
        updateFilters={updateRelationFilters}
        items={relationFilters}
        idField='key'
        onFilter={setFilterValue}
      />
      <FilterBody
        configNode={configNode}
        items={relationFilters}
        idField='key'
        filterValue={filterValue}
        updateFilter={updateRelationFilter}
        CellRenderItem={CellRenderItem}
      />
    </div>
  );
};

export default withFilterData(GraphFilterRelations, getRelations, relationFilterSelector);
